import { useCallback, useMemo, useState } from "react";

import { StatusChip } from "../design/StatusChip";
import { useT } from "../i18n/LocaleProvider";

// SWEEP S16. A SCREEN THAT LOADS SEVERAL LISTS MUST SAY WHEN ONE OF THEM FAILED.
// Fifteen reads in the console ignored a refusal and a dropped connection, leaving a
// dropdown silently empty — and the screens' own error state could not carry it, because
// the main load clears that state on success and erased the warning. This one only sets.
export function usePartialLoad(): { note: () => void; notice: JSX.Element | null } {
  const { t } = useT();
  const [missing, setMissing] = useState(false);
  const note = useCallback(() => setMissing(true), []);
  const notice = useMemo(
    () =>
      missing ? (
        <div className="form-message" role="status" aria-live="polite">
          <StatusChip tone="attention" label={t("Incomplete")} />
          <span>{t("Part of this page could not be loaded, so some choices may be missing. Reload to try again.")}</span>
        </div>
      ) : null,
    [missing, t],
  );
  return { note, notice };
}
